<div class="material-create">
  <div class="material-create__content">
    <div class="material-create__header">
      <div class="material-create__heading">
        <h1 class="page-title">Create Material</h1>
        <p class="page-subtitle">Add a new material to your catalog.</p>
      </div>
      <div class="material-create__actions">
        <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
        <app-button type="button" [disabled]="isSaving || materialForm.invalid" (click)="saveMaterial()">
          {{ isSaving ? "Creating..." : "Create material" }}
        </app-button>
      </div>
    </div>

    <div class="material-create__grid">
      <!-- Left Column: Image Gallery -->
      <div class="material-create__gallery">
        <div class="material-create__main-image">
          @if (avatarImageUrl) {
          <img [src]="avatarImageUrl" [alt]="avatarName" class="material-create__main-image-img" />
          } @else {
          <div class="material-create__main-image-placeholder">
            <ng-glyph name="image" size="64" class="material-create__main-image-icon"></ng-glyph>
            <span>No image</span>
          </div>
          }
        </div>
        <div class="material-create__gallery-actions">
          <input type="file" #avatarInput accept="image/*" (change)="onAvatarChange($event)" style="display: none" />
          <app-button type="button" variant="secondary" (click)="avatarInput.click()">
            <ng-glyph name="photo_camera" size="18"></ng-glyph>
            <span>Upload Image</span>
          </app-button>
          @if (avatarImageUrl) {
          <app-button type="button" variant="danger" (click)="removeAvatar()">
            <ng-glyph name="delete" size="18"></ng-glyph>
            <span>Remove</span>
          </app-button>
          }
        </div>
      </div>

      <!-- Right Column: Form Fields -->
      <div class="material-create__form-panel">
        <form [formGroup]="materialForm" class="material-create__form">
          <div class="material-create__form-field">
            <label for="name" class="material-create__form-label">Material Name</label>
            <input
              id="name"
              type="text"
              formControlName="name"
              class="material-create__form-input"
              [class.material-create__form-input--error]="materialForm.get('name')?.invalid && materialForm.get('name')?.touched"
              placeholder="Enter material name" />
            @if (materialForm.get('name')?.invalid && materialForm.get('name')?.touched) {
            <div class="material-create__form-error">Name is required and must be at least 2 characters</div>
            }
          </div>

          <div class="material-create__form-row">
            <div class="material-create__form-field">
              <label for="sku" class="material-create__form-label">SKU</label>
              <input
                id="sku"
                type="text"
                formControlName="sku"
                class="material-create__form-input"
                [class.material-create__form-input--error]="materialForm.get('sku')?.invalid && materialForm.get('sku')?.touched"
                placeholder="e.g., PRD-001" />
              @if (materialForm.get('sku')?.invalid && materialForm.get('sku')?.touched) {
              <div class="material-create__form-error">SKU is required</div>
              }
            </div>

            <div class="material-create__form-field">
              <label for="price" class="material-create__form-label">Price</label>
              <input
                id="price"
                type="text"
                inputmode="decimal"
                formControlName="price"
                class="material-create__form-input"
                [class.material-create__form-input--error]="materialForm.get('price')?.invalid && materialForm.get('price')?.touched"
                placeholder="0" />
              @if (materialForm.get('price')?.invalid && materialForm.get('price')?.touched) {
              <div class="material-create__form-error">Price is required</div>
              }
            </div>
          </div>

          <div class="material-create__form-field">
            <label for="dcmSeriesId" class="material-create__form-label">Series ID</label>
            <input
              id="dcmSeriesId"
              type="number"
              inputmode="numeric"
              min="1"
              step="1"
              formControlName="dcmSeriesId"
              class="material-create__form-input"
              [class.material-create__form-input--error]="
                materialForm.get('dcmSeriesId')?.invalid && materialForm.get('dcmSeriesId')?.touched
              "
              placeholder="e.g., 1" />
            @if (materialForm.get('dcmSeriesId')?.invalid && materialForm.get('dcmSeriesId')?.touched) {
            <div class="material-create__form-error">Series ID must be a positive whole number</div>
            }
          </div>

          <div class="material-create__form-field">
            <label for="description" class="material-create__form-label">Description</label>
            <app-rich-text-editor
              formControlName="description"
              [placeholder]="'Enter material description with rich formatting...'"></app-rich-text-editor>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
